<template>
  <menu-node
    :menu-box="true"
    :child-nodes="menuData"
  />
</template>

<script>
import MenuNode from '@/components/menu/MenuNode';

export default {
  name: 'SideMenu',
  components: { MenuNode },
  props: {
    menuData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>

</style>
